import { ImpactAssessment4 } from "./impact-assessment4";

export class BulkUpdateT4Model {
    itemIds: Array<number>;
    impactAssessment: ImpactAssessment4;
  
    constructor() {
      this.itemIds = [];
      this.impactAssessment = new ImpactAssessment4();
    }
  }